/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Notebook
 *| (C) Copyright IBM Corp. 2019, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/ui/interaction/Utils',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'../../../../app/util/ErrorUtils',
	'../../../../app/nls/StringResources'
], function(Utils, APIFactory, ContentActionsProviderAPI, ErrorUtils, stringResources) {

	// NOTE: DashboardWidget in jupyter-client relies on getAPI() for the hooks:
	// - this.selectedWidget.allowReconfigure()
	// - this.selectedWidget.editConfig()

	class EditNotebookAction {

		constructor({ features }) {
			this._dashboard = features.API;
			features.ContentActions.registerProvider('editNotebook', this.getAPI());
			this._features = features;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}

		destroy() {
			this._dashboard = null;
			this._features = null;
			this._api = null;
		}

		_isAvailable(idList) {
			let canAuthor = idList.length === 1 && this._features['DashboardState'].getUiState().authoring === true
				&& ErrorUtils.hasCapability(this._dashboard, 'canAuthorDashboard');
			if (canAuthor) {
				this._selectedWidget = this._dashboard.getCanvas().getWidget(idList[0]);
				return this._selectedWidget && typeof (this._selectedWidget.allowReconfigure) === 'function' && this._selectedWidget.allowReconfigure();
			}
			return false;
		}

		getContentActionList(idList) {
			if(this._isAvailable(idList)) {
				return [{
					name: 'editNotebook',
					label: stringResources.get('editNotebook'),
					icon: this._features['Icons'].getIcon('edit').id,
					type: 'Button',
					actions: {
						apply: this.triggerEdit.bind(this)
					}
				}];
			} else {
				return [];
			}
		}

		triggerEdit(/* event */) {
			this._selectedWidget.editConfig();
		}
	}
	return EditNotebookAction;
});
